import './SimpleRemark.less';
export { default as SimpleRemark } from './SimpleRemark.js';
export { default } from './SimpleRemark.js';